export const PANELTYPE_QUANTITY = [
  {
    id: '0d83af2c-ee63-4465-b6ea-9f3cf43d9dda',
    name: 'WallMountedPanels',
    availableQuantity: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    getBrandQuantity: numberOfPanels => {
      if (numberOfPanels <= 6) return 1;
      if (numberOfPanels <= 9) return 2;

      return 3;
    },
  },
  {
    id: '666fecaf-3379-4258-adfa-f91bce7e19bf',
    name: 'SquareTower',
    availableQuantity: [4],
    getBrandQuantity: numberOfPanels => {
      return 2;
    },
  },
  {
    id: '9893fd65-aab6-43cd-90bd-064ba7d21152',
    name: 'SquareTowerKit',
    availableQuantity: [4],
    getBrandQuantity: numberOfPanels => {
      return 2;
    },
  },
  {
    id: '20800fb8-ed1f-4b40-9522-063c5969a05c',
    name: 'FreeStandingPanelsDS',
    availableQuantity: [2, 3, 4],
    getBrandQuantity: numberOfPanels => {
      return 2;
    },
  },
  {
    id: 'd1f9e667-9984-4a62-8fa3-939053fd565c',
    name: 'FreeStandingPanelsSS',
    availableQuantity: [2, 3, 4],
    getBrandQuantity: numberOfPanels => {
      return 1;
    },
  },
];
